export default __webpack_public_path__ + "static/media/icon-close-modal.732388df.svg";